/** Street level on the dropped pin. */
const PIN_ZOOM = 18;

/**
 * Google Maps with a pin on this coordinate, opened at street level.
 * The map action centers the camera and draws no marker. The place path is
 * what drops the pin, and the @ camera is what keeps the zoom.
 */
export function getGoogleMapUrl(latitude: number, longitude: number): string {
  const point = `${latitude},${longitude}`;
  return `https://www.google.com/maps/place/${point}/@${point},${PIN_ZOOM}z`;
}
